import { Injectable } from '@angular/core';

import { PedidoItem } from '../item';
import { toFixed } from '../../../core/services/utils/numbers';

@Injectable({
    providedIn: 'root'
})
export class PedidoImpostoCalculoService {

    /** Calcula o valor total do ICMS do pedido */
    calcularValorIcms(pedidoItens: PedidoItem[]) {
        if (!pedidoItens) {
            return 0;
        }

        let valorIcms = 0;
        pedidoItens.forEach(pedidoItem => {
            valorIcms += pedidoItem.drp?.valorIcms ? Number(pedidoItem.drp.valorIcms) : 0;
        });

        return toFixed(valorIcms, 2);
    }

    /** Calcula o valor total do IPI do pedido */
    calcularValorIpi(pedidoItens: PedidoItem[]) {
        if (!pedidoItens) {
            return 0;
        }

        let valorIpi = 0;
        pedidoItens.forEach(pedidoItem => {
            valorIpi += pedidoItem.drp?.valorIpi ? Number(pedidoItem.drp.valorIpi) : 0;
        });

        return toFixed(valorIpi, 2);
    }
}
